import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  Box,
  Collapse,
  Flex,
  Text,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import { ReactNode } from "react";

interface ProfileSectionCardProps {
  title?: string;
  isCollapsible?: boolean;
  defaultIsOpen?: boolean;
  children: ReactNode;
}

export const ProfileSectionCard = ({
  title,
  isCollapsible = false,
  defaultIsOpen = true,
  children,
}: ProfileSectionCardProps) => {
  const background = useColorModeValue("white", "gray.700");
  const borderColor = useColorModeValue("gray.100", "gray.600");
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen });

  const collapsible = isCollapsible && Boolean(title);

  return (
    <Box
      as="section"
      background={background}
      border="1px solid"
      borderColor={borderColor}
      borderRadius="xl"
      px={6}
      py={5}
    >
      {collapsible ? (
        <>
          <Flex
            as="button"
            type="button"
            w="100%"
            alignItems="center"
            justifyContent="space-between"
            textAlign="left"
            onClick={onToggle}
            aria-expanded={isOpen}
          >
            <Text as="h3" fontSize="md" fontWeight="bold">
              {title}
            </Text>
            <ChevronDownIcon
              boxSize={5}
              transform={isOpen ? "rotate(180deg)" : undefined}
              transition="transform 0.2s"
            />
          </Flex>
          <Collapse in={isOpen} animateOpacity>
            <Box pt={4}>{children}</Box>
          </Collapse>
        </>
      ) : (
        <>
          {title && (
            <Text as="h3" fontSize="md" fontWeight="bold" mb={4}>
              {title}
            </Text>
          )}
          {children}
        </>
      )}
    </Box>
  );
};
